var klaviyo = klaviyo || [];
klaviyo.init({
  account: "Wb2LbP",
  platform: "shopify",
  include_on_tags: "back-stock"
});

let _parrafo, _email,_success,_close  = "";

// --------------------------- EN INGLÈS ---------------------------
if (window.location.pathname.includes("/en/")) {
  _parrafo = "➡️ We've run out of this product. 😔";
  _email = "Email";
  _button = "➡️ I would have liked to get it. 🙏";
  _success = "Thank you for signing up. <br> If we finally have this product back in stock, we will let you know. 📩 <br>";
  _close = "Close";
}
// --------------------------- EN ESPAÑOL ---------------------------
else {
  _parrafo = "➡️ Nos hemos quedado sin este producto. 😔";
  _email = "Email";
  _button = "➡️ Me habría gustado conseguirlo. 🙏";
  _success = "Gracias por apuntarte. <br> Si finalmente tenemos este producto de nuevo en stock, te avisaremos. 📩 <br>";
  _close = "Cerrar";
}



klaviyo.enable("backinstock",{ 
  trigger: {
    product_page_text: "Notify Me When Available",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false
  },
  modal: {
   headline: "{product_name}",
   body_content: _parrafo,
   email_field_label: _email,
   button_label: _button,
   subscription_success_label: _success,
   footer_content: '',
   additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
   drop_background_color: "#000",
   background_color: "#fff",
   text_color: "#222",
   button_text_color: "#fff",
   button_background_color: "#ff998a",
   close_label:_close,
   close_button_color: "#ff998a",
   error_background_color: "#fcd6d7",
   error_text_color: "#C72E2F",
   success_background_color: "#ff998a",
   success_text_color: "#fff"
  }
});

